import * as helpers from '../../js/helpers';

export default function sameCategory() {
    const sameCatBlock = document.querySelector('.same-category:not(.-is-initialized):not(.-extranet)');
    const pageDetailPopup = document.querySelector('.page-detail');

    if (!sameCatBlock) {
        return;
    }

    sameCatBlock.classList.add('-is-initialized');

    let titles = document.querySelector('.site-content').getElementsByTagName('h2');

    if (pageDetailPopup) {
        titles = pageDetailPopup.querySelector('.site-content').getElementsByTagName('h2');
    }

    if (titles === null) {
        return;
    }

    const listWrap = sameCatBlock.querySelector('.same-category__list');
    const btnToggle = sameCatBlock.querySelector('.same-category__toggle');
    const header = document.querySelector('.header-bar');

    if (titles.length > 0) {
        for (let i = 0; i < titles.length; i++) {
            const itemText = titles[i].textContent;
            const item = document.createElement('li');
            const linkItem = document.createElement('a');
            const itemId = helpers.getUniqId();

            titles[i].setAttribute('id', `f${itemId}`);
            helpers.addClass(item, 'same-category__item');
            linkItem.setAttribute('href', `#f${itemId}`);

            linkItem.textContent = itemText;
            item.appendChild(linkItem);
            listWrap.appendChild(item);
        }
    } else {
        if (sameCatBlock.parentNode) {
            sameCatBlock.parentNode.parentNode.removeChild(sameCatBlock.parentNode);
        }
    }

    function scrollAnimation() {
        const listLinks = listWrap.querySelectorAll('[href^="#"]');
        const speed = 0.35;

        for (let i = 0; i < listLinks.length; i++) {
            listLinks[i].addEventListener('click', (e) => {
                e.preventDefault();
                btnToggle.click();
                btnToggle.innerHTML = listLinks[i].innerHTML;
                // listLinks[i].setAttribute('aria-current', 'page');
                let headerHeight = 0;

                if (header) {
                    headerHeight = helpers.outerHeight(header);
                }

                const sameCatBlockHeight = window.responsive === 'desktop' ? 0 : helpers.outerHeight(sameCatBlock);
                const windowYOffset = pageDetailPopup ? pageDetailPopup.scrollTop : window.pageYOffset;
                const hash = listLinks[i].getAttribute('href');
                const elementPosition = document.querySelector(hash).getBoundingClientRect().top - headerHeight - sameCatBlockHeight;
                let start = null;

                function step(time) {
                    if (start === null) start = time;
                    const progress = time - start;
                    const r = elementPosition < 0
                        ? Math.max(windowYOffset - (progress / speed), windowYOffset + elementPosition)
                        : Math.min(windowYOffset + (progress / speed), windowYOffset + elementPosition);
                    const scroll = pageDetailPopup ? pageDetailPopup.scrollTo(0, r) : window.scrollTo(0, r);
                    if (r !== windowYOffset + elementPosition) {
                        requestAnimationFrame(step);
                    }
                }

                requestAnimationFrame(step);
            }, false);
        }
    }

    scrollAnimation();
}
